import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_MARKET_RATES_ACTION_TYPE } from '../actions/marketRates.actions';

const initialState = null;

const marketRatesReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_MARKET_RATES_ACTION_TYPE.SET_MARKET_RATES:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default marketRatesReducer;
